import JSEncrypt from 'jsencrypt';
import { getPublicKey } from '@/api/user';

export async function encrypt(data) {
  /*
    const res = await getPublicKey();
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(res.data);
    return encrypt.encrypt(JSON.stringify(data));
    */
  return data;
}

/**
 * Base64 字符串转字节数组
 * @param {String} base64
 * @returns {Uint8Array}
 */
function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/**
 * 字节数组转 Base64 字符串
 * @param {Uint8Array} bytes
 * @returns {String}
 */
function bytesToBase64(bytes) {
  let binary = '';
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary);
}

/**
 * DER 长度编码（支持短格式与长格式）
 * @param {Number} length
 * @returns {Array}
 */
function derLength(length) {
  if (length < 0x80) {
    return [length];
  }
  const hex = length.toString(16);
  const arr = (hex.length % 2 ? '0' + hex : hex).match(/../g).map((h) => parseInt(h, 16));
  return [0x80 + arr.length, ...arr];
}

/**
 * DER INTEGER 编码（去掉多余前导 0，最高位为 1 时补 0 保证正数）
 * @param {Uint8Array} bytes
 * @returns {Array}
 */
function derInteger(bytes) {
  let data = [...bytes];
  while (data.length > 1 && data[0] === 0) {
    data.shift();
  }
  if (data[0] & 0x80) {
    data = [0, ...data];
  }
  return [0x02, ...derLength(data.length), ...data];
}

/**
 * DER SEQUENCE 编码
 * @param {Array} children
 * @returns {Array}
 */
function derSequence(children) {
  const body = children.flat();
  return [0x30, ...derLength(body.length), ...body];
}

/**
 * 将 XML 格式 RSA 公钥（<RSAKeyValue>）转换为 jsencrypt 支持的 PEM（PKCS#1）格式
 * jsencrypt 3.x 不支持 XML 格式公钥，必须转为 PEM 才能加密
 * @param {String} xml
 * @returns {String}
 */
export function xmlPublicKeyToPem(xml) {
  const modulus = xml.match(/<Modulus>([^<]*)<\/Modulus>/);
  const exponent = xml.match(/<Exponent>([^<]*)<\/Exponent>/);
  if (!modulus || !exponent) {
    throw new Error('无效的RSA公钥');
  }
  const n = base64ToBytes(modulus[1]);
  const e = base64ToBytes(exponent[1]);
  const der = derSequence([derInteger(n), derInteger(e)]);
  const b64 = bytesToBase64(der);
  const lines = b64.match(/.{1,64}/g).join('\n');
  return '-----BEGIN RSA PUBLIC KEY-----\n' + lines + '\n-----END RSA PUBLIC KEY-----';
}
